import { render } from "./RegisterMid.vue?vue&type=template&id=6fde1c61"
const script = {}

import "./RegisterMid.vue?vue&type=style&index=0&id=6fde1c61&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__